
import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DriverBaseComponent } from '../../../driver/driver-base-component';

export class AdditionalRequirementsModalComponentContext {
    constructor(public customerNumberId: number, public incidentTypeId: number) {
    }
}

@Component({
    selector: 'additional-requirements-modal',
    templateUrl: './additional-requirements-modal.html'
})
export class AdditionalRequirementsModalComponent extends DriverBaseComponent {
    public customerNumberId: number;
    public incidentTypeId: number;

    constructor(
        public dialogRef: MatDialogRef<AdditionalRequirementsModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: AdditionalRequirementsModalComponentContext
    ) {
        super();
        this.customerNumberId = data.customerNumberId;
        this.incidentTypeId = data.incidentTypeId;
    }

    public ngOnInit() {
    }

    public cancel() {
        this.dialogRef.close();
    }

    public close() {
        this.dialogRef.close();
    }

    public save(){
    }
}
